import {DefaultEdit} from "../components/DefaultEdit";
import {TagForm} from "./TagForm";
import {EditProps} from "react-admin";


export const TagEdit = (props: EditProps) => {
    return (
        <DefaultEdit {...props}>
            <TagForm />
        </DefaultEdit>
    )
}